import { Checkbox, Stack } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { memo, useContext } from "react";
import { DashboardsTableContext } from "../../../../../contexts/TablesContext/DashboardsTableProvider";

const useStyles = makeStyles((theme) => ({
    checkBox: {
        padding: 'unset !important',
        marginRight: '4px !important',
        "& > svg": {
            width: '20px !important',
            height: '20px !important',
        }
    },
}));

const SelectionColumn: React.FC<{}> = () => {
    const { filters, setFilters } = useContext(DashboardsTableContext);
    const classes = useStyles();

    return (<>
        <Stack alignItems="center" justifyContent="center" width="100%" pl="12px">
            <Checkbox edge="end"
                className={classes.checkBox}
                checked={filters.added?.some(added => added === '+Infinity')}
                onClick={() => setFilters({ added: !filters.added?.some(added => added === '+Infinity') ? ['+Infinity'] : [] })}
                disableRipple />
        </Stack>
    </>);
}

export default memo(SelectionColumn);
